import { render, staticRenderFns } from "./AttachementIcon.vue?vue&type=template&id=176acb9d&scoped=true"
import script from "./AttachementIcon.vue?vue&type=script&lang=js"
export * from "./AttachementIcon.vue?vue&type=script&lang=js"
import style0 from "./AttachementIcon.vue?vue&type=style&index=0&id=176acb9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176acb9d",
  null
  
)

export default component.exports